import Subject from "../cse4sub/Subject";
import React from 'react'
import cse307 from '../assets/CSE307end21.pdf'

export default function DeLab() {
  return (
    <div>
       <Subject title="Digital Electronics Lab(CSE307)" 
    book1=" " book2=" "
    book1Link="#" book2Link="#" int21="#" mid21="#" end21={cse307}
     int20="#" mid20="#" end20="#" mid="---"
    />
    </div>
  )
}